import { IonFab, IonFabButton, IonFabList } from "@ionic/react";
import { useIntl } from "react-intl";

import MessagesFab from "@components/MessagesFab";
import Icon from "@components/text/Icon";
import useGlobalOpener from "@hooks/useGlobalOpener";
import { OpenerTypeEnum } from "@typing/Enums";

type Props = {
  journeyId: string;
};

const ExpertFabs = ({ journeyId }: Props) => {
  const intl = useIntl();

  const tagsOpener = useGlobalOpener(OpenerTypeEnum.TAGS);
  const tasksOpener = useGlobalOpener(OpenerTypeEnum.TASKS);

  const queryParams = new URLSearchParams(location.search);
  const hideFab = queryParams.has("hideFab");

  if (hideFab) {
    return null;
  }

  return (
    <IonFab horizontal="end" slot="fixed" vertical="bottom">
      <IonFabButton aria-label={intl.formatMessage({ id: "accessibility.ariaLabels.actions" })} size="small">
        <Icon color="white" icon="plus" />
      </IonFabButton>
      <IonFabList side="top">
        <IonFabButton
          aria-label={intl.formatMessage({ id: "accessibility.ariaLabels.toggleTags" })}
          color="primary-300"
          onClick={tagsOpener.toggle}
        >
          <Icon color="white" icon="tags" />
        </IonFabButton>
        <IonFabButton
          aria-label={intl.formatMessage({ id: "accessibility.ariaLabels.toggleTasks" })}
          color="primary-500"
          onClick={tasksOpener.toggle}
        >
          <Icon color="white" icon="clipboardListCheck" />
        </IonFabButton>
        <MessagesFab journeyId={journeyId} />
      </IonFabList>
    </IonFab>
  );
};

export default ExpertFabs;
